//#region Imports
import * as React from "react";
import type { IAuthInternalContextValue } from "./auth-react-types";
//#endregion

export const AuthContext = React.createContext<IAuthInternalContextValue | undefined>(undefined);
if (__DEV__) AuthContext.displayName = "AuthContext";
